import React from 'react';
import ToolTile from './ToolTile';

// Recreate API similar to Polymet: <CategoryCard category={category} />
const CategoryCard = ({ category, onSeeAll }) => {
  const label = category.label;
  const colorClass = category.color || 'text-succession-primary';
  const bgClass = category.bgColor || 'bg-succession-bg-primary';
  const tools = category.tools || [];
  const bgInline = category.bgInline;
  const seeAllHref = category.seeAllHref;
  return (
    <div className={`relative rounded-2xl px-3 py-1 min-h-[88px] ${bgClass}`} style={{ paddingTop: '6px', paddingBottom: '6px', ...(bgInline ? { backgroundColor: bgInline } : {}) }}>
      <div className="flex items-center justify-between mb-1 py-1">
        <span className={`text-lg font-bold text-gray-900`}>{label}</span>
        {seeAllHref ? (
          <a
            href={seeAllHref}
            className={`text-xs font-medium h-6 px-2 rounded-md hover:bg-white/50 ${colorClass}`}
            onClick={() => onSeeAll && onSeeAll(label)}
          >
            See All
            <span className="ml-1">›</span>
          </a>
        ) : (
          <button
            type="button"
            className={`text-xs font-medium h-6 px-2 rounded-md hover:bg-white/50 ${colorClass}`}
            onClick={() => onSeeAll && onSeeAll(label)}
          >
            See All
            <span className="ml-1">›</span>
          </button>
        )}
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-1 mt-0 justify-items-center">
        {(tools || []).slice(0, 4).map((tool) => (
          <ToolTile
            key={`${label}-${tool.id || tool.label}`}
            label={tool.label}
            href={tool.route || tool.href}
            comingSoon={tool.comingSoon}
            icon={tool.icon}
            category={label}
          />
        ))}
      </div>

      <div className="absolute top-3 right-3 opacity-10">
        <div className="w-8 h-8 rounded-full bg-succession-primary/10" />
      </div>
    </div>
  );
};

export default CategoryCard;


